import { render } from "./MovimentacaoDePara.vue?vue&type=template&id=715dc18e&scoped=true"
import script from "./MovimentacaoDePara.vue?vue&type=script&lang=js"
export * from "./MovimentacaoDePara.vue?vue&type=script&lang=js"

import "./MovimentacaoDePara.vue?vue&type=style&index=0&id=715dc18e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715dc18e"]])

export default __exports__